import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import { getTourInput, getToursInput, TourLiteModel, TourModel } from './model';

export function useGetTours(
  input?: getToursInput,
  options?: UseQueryOptions<ExtendedApiResult<TourLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<TourLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getTours', input?.params],
      () =>
        QueryFetchFunction({
          url: 'tours',
          params: input?.params,
        }),
      options,
    ),
    TourLiteModel,
  );
}

export function useGetTour(
  input?: getTourInput,
  options?: UseQueryOptions<ApiResult<TourModel>, ApiError>,
): UseQueryResult<ApiResult<TourModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getTour', input?.id],
      () =>
        QueryFetchFunction({
          url: `tours/${input?.id}`,
        }),
      options,
    ),
    TourModel,
  );
}

export function getToursKey(input?: getToursInput) {
  return ['getTours', input?.params];
}

export function getTourKey(input?: getTourInput) {
  return ['getTour', input?.id];
}
